import gql from 'graphql-tag';

const CAMPAIGN_ORDER_TRANSACTIONS_DETAILS = gql`
  query campaignOrderTransactionsDetails($where: CampaignOrderWhereUniqueInput!) {
    campaignOrder(where: $where) {
      id
      reportDetails {
        id
        transaction {
          id
          transactions
          revenue
          spend
          customers
          roas
          byDate {
            date
            transactions
            revenue
            spend
            customers
            impressions
            uniqueIdentifiers
          }
          creatives {
            media
            name
            impressions
            transactions
          }
          publisher {
            media
            name
            impressions
            transactions
          }
          transactionsByCampaign {
            id
            adProviderId
            campaignName
            cpm
            transactions
            revenue
            spend
            impressions
            roas
            customers
            byDate {
              date
              transactions
              revenue
              spend
              impressions
            }
          }
        }
      }
    }
  }
`;

export default CAMPAIGN_ORDER_TRANSACTIONS_DETAILS;
